import { MapPin } from "lucide-react";
import { AREAS, waLink } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

export default function Areas() {
  return (
    <section id="areas" data-testid="areas-section" className="scroll-mt-24 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <SectionHead
          overline="Áreas de Serviço"
          title="Onde trabalhamos"
          text="Trabalhamos em Arruda dos Vinhos, Alenquer, Vila Franca de Xira, Loures e em várias zonas da região de Lisboa."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {AREAS.map((a, i) => (
            <Reveal key={a.name} delay={0.06 * i}>
              <div
                data-testid={`area-card-${i}`}
                className="h-full rounded-3xl border border-stone2 bg-white p-6 transition-shadow duration-300 hover:shadow-[0_20px_50px_-20px_rgba(18,37,26,0.2)]"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-lime-100 text-lime-700">
                  <MapPin size={18} />
                </span>
                <h3 className="mt-4 font-serif text-lg text-ink">{a.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-moss">{a.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-moss">
            Não encontra a sua localidade?{" "}
            <a
              data-testid="areas-whatsapp-link"
              href={waLink("Olá EcoJard! Gostaria de saber se trabalham na minha zona.")}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-pine underline decoration-lime-500 decoration-2 underline-offset-4 hover:text-lime-700"
            >
              Fale connosco no WhatsApp
            </a>
            : avaliamos deslocações noutras zonas.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
